// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import AuditLogView from "./view";

import PendingComponent from "../../../../components/PendingComponent";
import { isMeaningfulGigsRole } from "../../../../utils/auth";
import { authLayoutRoute } from "../../../auth-layout/route";
import { ticketsRoute } from "../../../tickets/route";

export const auditLogRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "roi/audit",
  validateSearch(search: Record<string, unknown>) {
    const schema = z.object({
      page: z.coerce.number().optional(),
      // Array of atomic task IDs to filter by
      atomicTasks: z
        .union([z.string(), z.array(z.string())])
        .transform((val) =>
          Array.isArray(val) ? val : val ? [val] : undefined,
        )
        .optional(),
      // Date range for cycle_start filter
      startDate: z.string().optional(),
      endDate: z.string().optional(),
    });

    return schema.parse(search);
  },
  beforeLoad() {
    // Only allow meaningful gigs role to access ROI audit log
    if (!isMeaningfulGigsRole()) {
      throw redirect({
        to: ticketsRoute.to,
      });
    }
  },
  loaderDeps({ search }) {
    return search;
  },
  async loader({ deps }) {
    return {
      page: deps.page,
      atomicTasks: deps.atomicTasks,
      startDate: deps.startDate,
      endDate: deps.endDate,
    };
  },
  component: AuditLogView,
  pendingComponent: PendingComponent,
  gcTime: 0,
  shouldReload: false,
  pendingMs: 0,
  pendingMinMs: 500,
});
